import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CrmInteractionRating } from "@enums/crmInteractionRating.enum";
import { InteractionType } from "@enums/interactionType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { CrmInteractionService } from "@services/crmInteraction.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "crm-interactions",
	styleUrls: ["crmInteractions.css"],
	templateUrl: "crmInteractions.html"
})
export class CrmInteractionsAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	interactionTypes: any[] = [];
	itemType = "CRM Interaction";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	userProfiles: UserProfile[] = [];

	constructor(private router: Router, private toastService: ToastService, private itemService: CrmInteractionService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService, private userProfileService: UserProfileService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.interactionTypes = GetPropertiesFromEnum(InteractionType);
		this.getRatingEmoji = this.getRatingEmoji.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.getUserProfiles();
		this.checkGridExportPermissions();
	}

	addNewItem() { this.router.navigate([`${this.itemUrl}/create`]); }

	checkGridExportPermissions() {
		this.protectedGridService.canExport("CrmInteractions").subscribe((res: any) => { this.canExportGrid = res.response; });
	}

	deleteRow(e: any) {
		if (confirm("Are you sure you want to delete this interaction?")) {
			this.itemService.deleteSingleById(e.row.data.id).subscribe(
				() => { this.toastService.success("Interaction deleted!"); this.getItems(); },
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
		}
	}

	editRow(e: any) { this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]); }

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll().subscribe(
			(res: any) => { this.items = res.response.items; this.gridLoading = false; },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	getRatingEmoji(data: any): string {
		if (data.rating === CrmInteractionRating.Positive) return "😊";
		if (data.rating === CrmInteractionRating.Neutral) return "😐";
		if (data.rating === CrmInteractionRating.Negative) return "😞";
		return "";
	}

	getUserProfiles() {
		this.userProfileService.getAll().subscribe(
			(res: any) => { this.userProfiles = res.response.items; },
			(err) => { console.log(err); }
		);
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "CrmInteractions";
		this.exportLogService.logExport(logExport).subscribe();
	}

	viewRow(e: any) { this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]); }
}
